/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext } from 'react';
import { CoreContext } from '../../../context/CoreContext';

import { VideoHeaderContainer, VideoClose, VideoCloseIcon } from './styled';

import VideoInformations from '../Information';
import { useNavigate } from '@reach/router';

export default function VideoHeader({
  details,
  ...rest
}: {
  details: { title?: string; [key: string]: unknown };
  [key: string]: unknown;
}) {
  const { setCurrentVideo } = useContext(CoreContext);
  const navigate = useNavigate(rest);

  const back = () => {
    navigate('/catalog');
    setCurrentVideo(null);
  };

  return (
    <>
      <VideoHeaderContainer>
        <VideoClose onEnterPress={back} onPress={back}>
          <VideoCloseIcon />
        </VideoClose>
        <VideoInformations details={details} />
      </VideoHeaderContainer>
    </>
  );
}
